<template>
  <div class="skeleton-container">
    <!-- 轮播图骨架 -->
    <div class="skeleton-hero">
      <el-skeleton :loading="loading" animated>
        <template #template>
          <el-skeleton-item variant="image" style="width: 100%; height: 600px;" />
        </template>
      </el-skeleton>
    </div>

    <!-- 业务板块骨架 -->
    <div class="skeleton-section container">
      <el-skeleton :loading="loading" animated>
        <template #template>
          <div style="padding: 30px 0; text-align: center;">
            <el-skeleton-item variant="h1" style="width: 30%; margin: 0 auto 20px;" />
            <el-skeleton-item variant="text" style="width: 60%; margin: 0 auto;" />
          </div>
          <div style="display: flex; gap: 30px; margin-top: 40px;">
            <div style="flex: 1;">
              <el-skeleton-item variant="image" style="width: 100%; height: 300px;" />
              <div style="padding: 14px;">
                <el-skeleton-item variant="h3" style="width: 50%" />
                <el-skeleton-item variant="text" style="margin-right: 16px" />
                <el-skeleton-item variant="text" style="width: 30%" />
              </div>
            </div>
            <div style="flex: 1;">
              <el-skeleton-item variant="image" style="width: 100%; height: 300px;" />
              <div style="padding: 14px;">
                <el-skeleton-item variant="h3" style="width: 50%" />
                <el-skeleton-item variant="text" style="margin-right: 16px" />
                <el-skeleton-item variant="text" style="width: 30%" />
              </div>
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  loading: {
    type: Boolean,
    default: true
  }
});
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.skeleton-section {
  margin-top: 60px;
}
</style>
